import { LOCAL_USER_EMAIL } from "../../storage"
import {
  EXPORT_EXIST_DIVISION,
  EXPORT_TEMPLATE_DIVISION,
  IMPORT_DIVISIONS,
  IMPORT_FAILED_DIVISIONS,
} from "../events"
import { identifyUserSegment } from "../segmentTracks"

/**
 *
 * @param message customize message from the API : Success, Failed
 * @param summary array of import, update, error divisition
 * @param attempts the number of reload the file
 */

export const importDivisionSegment = (message, summary, attempts) => {
  window.analytics.track(IMPORT_DIVISIONS, {
    numero_importaciones: attempts,
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    resumen: {
      divisiones_importados: summary.count_import,
      divisiones_actualizados: summary.count_update,
      divisiones_sin_importar: summary.count_errors,
    },
    ph_divisiones_importados: summary.count_import,
    ph_divisiones_actualizados: summary.count_update,
    ph_divisiones_sin_importar: summary.count_errors,
    respuesta: message,
  })
}

/**
 *
 * @param status
 * @param option
 * @param listDivision
 */
export const exportDivisionSegment = (status, option, listDivision) => {
  const event = option.replace(/ /g, "")
  switch (event) {
    case "exportTemplate": //
      window.analytics.track(EXPORT_TEMPLATE_DIVISION, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        respuesta: status,
      })
      break
    case "exportDivisions": //
      window.analytics.track(EXPORT_EXIST_DIVISION, {
        data: identifyUserSegment(),
        email: LOCAL_USER_EMAIL(),
        total_divisiones: listDivision,
        respuesta: status,
      })
      break
  }
}

/**
 *
 * @param status
 */
export const importDivisionErrorSegment = (status) => {
  window.analytics.track(IMPORT_FAILED_DIVISIONS, {
    data: identifyUserSegment(),
    email: LOCAL_USER_EMAIL(),
    respuesta: status,
  })
}
